var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSorter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8F9BB3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.608 1c-.921 0-1.705.622-1.958 1.475H.553C.23 2.475 0 2.728 0 3.05a.57.57 0 00.576.576h2.097c.23.852 1.037 1.475 1.959 1.475a2.06 2.06 0 001.981-1.475h8.503a.57.57 0 00.576-.576.57.57 0 00-.576-.576H6.613A2.11 2.11 0 004.608 1zm.024 1.152a.9.9 0 010 1.797.9.9 0 010-1.797zM11.544 5.608c-.921 0-1.705.623-1.958 1.475H.576A.557.557 0 000 7.66a.57.57 0 00.576.576h9.01c.23.853 1.037 1.475 1.958 1.475a2.06 2.06 0 001.982-1.475h1.59a.57.57 0 00.576-.576.57.57 0 00-.576-.576h-1.59a2.06 2.06 0 00-1.982-1.475zm.023 1.153a.9.9 0 010 1.797.9.9 0 01-.898-.899c0-.507.391-.898.898-.898zM7.374 10.678c-.922 0-1.706.622-1.96 1.474H.577A.557.557 0 000 12.73a.57.57 0 00.576.576h4.862c.23.852 1.037 1.474 1.959 1.474a2.06 2.06 0 001.981-1.474h5.738a.57.57 0 00.576-.576.57.57 0 00-.576-.577h-5.76a2.06 2.06 0 00-1.982-1.474zm.023 1.152a.9.9 0 010 1.797.9.9 0 01-.9-.898c.024-.507.416-.9.9-.9z"
  }))));
}

export default SvgSorter;